// extracted by mini-css-extract-plugin
export default {"wrapper":"_0aYKV0G1--styles_wrapper__Csl3y","wiggle":"_0aYKV0G1--styles_wiggle__IXPwI","shimmer":"_0aYKV0G1--styles_shimmer__2Fk-R"};